/* RESPONSIBLE TEAM: team-ai-agent */
import BaseValidator from 'ember-cp-validations/validators/base';
import { inject as service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import type IntlService from 'embercom/services/intl';
import type Fin from 'embercom/models/operator/visual-builder/step/fin';

export default class FinEcommerceChannel extends BaseValidator {
  @service declare intl: IntlService;

  validate(_value: unknown, _options: ValidationOptions, model: Fin) {
    if (!model.isFinEcommerce) {
      return true;
    }

    let editorConfig = model.editorConfig;
    if (!editorConfig) {
      return true;
    }

    let targetChannels: string[] | undefined =
      (editorConfig as { targetChannels?: string[] }).targetChannels ||
      model.contentEditorService.activeObject?.targetChannels;

    if (isEmpty(targetChannels)) {
      return true;
    }

    let supportedChannels = model.supportedChannels;
    let unsupportedChannels = targetChannels!.filter((channel: string) => {
      if (channel === 'all_channels') {
        return false;
      }
      return !(supportedChannels as readonly string[]).includes(channel);
    });

    if (!isEmpty(unsupportedChannels)) {
      let channelNames = unsupportedChannels.map((channel: string) =>
        this.intl.t('operator.workflows.channels.type', { channel }),
      );
      return this.intl.t(
        'operator.workflows.visual-builder.validations.fin-ecommerce-not-supported-by-channel',
        {
          channels: channelNames.join(', '),
        },
      );
    }

    return true;
  }

  static getDependentsFor(_: string, options: { extraDependents?: string[] }) {
    return [
      'model.isFinEcommerce',
      'model.selectedAgent',
      'model.supportedChannels',
      'model.editorConfig',
      'model.editorConfig.targetChannels',
      'model.contentEditorService.activeObject.targetChannels.[]',
    ].concat(options.extraDependents || []);
  }
}
